import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { BoxProps } from './ui';

interface Props extends Pick<BoxProps, 'padding' | 'margin'> {}

const SIDES = ['Top', 'Right', 'Bottom', 'Left'] as const;

const buildSpacing = (
  prop: 'padding' | 'margin',
  value: BoxProps['padding'],
  spacing: (value: number) => string | number
) => {
  if (value === undefined) {
    return {};
  }

  if (typeof value === 'number') {
    return { [prop]: spacing(value) };
  }

  return SIDES.reduce((styles, side) => {
    const sideValue = value[side.toLowerCase() as 'top' | 'right' | 'bottom' | 'left'];

    if (sideValue !== undefined) {
      styles[`${prop}${side}`] = spacing(sideValue);
    }

    return styles;
  }, {} as Record<string, string | number>);
};

export const useStyles = makeStyles(({ spacing }) => ({
  container: ({ padding, margin }: Props) => ({
    ...buildSpacing('padding', padding, spacing),
    ...buildSpacing('margin', margin, spacing)
  })
}));
